import React from "react"
import { DatePicker } from "material-ui"
import AuthenticationStore from "../../stores/AuthenticationStore"
import { IDate, ELanguage } from "../../models"
import moment from "moment"
interface IProps {
    id?: string
    name?: string
    style?: React.CSSProperties
    dialogContainerStyle?: React.CSSProperties
    floatingLabelStyle?: React.CSSProperties
    errorStyle?: React.CSSProperties
    textFieldStyle?: React.CSSProperties
    cancelLabel?: string | React.ReactElement
    floatingLabelText?: string
    firstDayOfWeek?: number
    disabled?: boolean
    value?: IDate
    errorText?: string
    maxDate?: IDate
    minDate?: IDate
    hintText?: string
    autoOk?: boolean
    defaultDate?: Date
    container?: "dialog" | "inline"
    formatDate?(date: Date): any
    onChange?(e, date): void
    onDismiss?(): void
}
interface IState {

}

export default class FinddDatePicker extends React.Component<IProps, IState> {
    private DatePicker
    constructor(props: IProps) {
        super(props)
        this.state = {

        }
    }

    render() {
        const language = AuthenticationStore.getLoggedInUserLanguage()
        const locale = language === ELanguage.English ?
            "en-US" :
            language === ELanguage.Français ?
                "fr" :
                language === ELanguage.Español &&
                "es"
        return (
            <DatePicker
                ref={elem => this.DatePicker = elem}
                id={this.props.id}
                name={this.props.name}
                style={this.props.style}
                dialogContainerStyle={this.props.dialogContainerStyle}
                floatingLabelStyle={this.props.floatingLabelStyle}
                errorStyle={this.props.errorStyle}
                textFieldStyle={this.props.textFieldStyle}
                cancelLabel={this.props.cancelLabel}
                firstDayOfWeek={this.props.firstDayOfWeek}
                floatingLabelText={this.props.floatingLabelText}
                disabled={this.props.disabled}
                value={this.props.value && moment(this.props.value).toDate()}
                errorText={this.props.errorText}
                maxDate={this.props.maxDate && moment(this.props.maxDate).toDate()}
                minDate={this.props.minDate && moment(this.props.minDate).toDate()}
                hintText={this.props.hintText}
                autoOk={this.props.autoOk}
                defaultDate={this.props.defaultDate}
                container={this.props.container}
                formatDate={this.props.formatDate}
                onChange={this.props.onChange}
                onDismiss={this.props.onDismiss}
                locale={locale}
                DateTimeFormat={global.Intl.DateTimeFormat}
            />
        )
    }
}